export default __webpack_public_path__ + "static/media/sliders.623f0d0b.svg";